var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTildiLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5999 12.7101C10.5061 12.6171 10.4317 12.5065 10.381 12.3846C10.3302 12.2628 10.3041 12.1321 10.3041 12.0001C10.3041 11.868 10.3302 11.7373 10.381 11.6155C10.4317 11.4936 10.5061 11.383 10.5999 11.2901L15.1899 6.71006C15.2836 6.6171 15.358 6.5065 15.4088 6.38464C15.4595 6.26278 15.4857 6.13207 15.4857 6.00006C15.4857 5.86805 15.4595 5.73734 15.4088 5.61548C15.358 5.49362 15.2836 5.38302 15.1899 5.29006C15.0025 5.10381 14.749 4.99927 14.4849 4.99927C14.2207 4.99927 13.9672 5.10381 13.7799 5.29006L9.18986 9.88006C8.62806 10.4426 8.3125 11.2051 8.3125 12.0001C8.3125 12.7951 8.62806 13.5576 9.18986 14.1201L13.7799 18.7101C13.9661 18.8948 14.2175 18.999 14.4799 19.0001C14.6115 19.0008 14.7419 18.9756 14.8638 18.9258C14.9856 18.8761 15.0964 18.8027 15.1899 18.7101C15.2836 18.6171 15.358 18.5065 15.4088 18.3846C15.4595 18.2628 15.4857 18.1321 15.4857 18.0001C15.4857 17.868 15.4595 17.7373 15.4088 17.6155C15.358 17.4936 15.2836 17.383 15.1899 17.2901L10.5999 12.7101Z",
    fill: "#405C43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildiLeftArrowIcon);
export default __webpack_public_path__ + "static/media/tildi-left-arrow-icon.d9d5ed7a2e2df3dfb7a9b3a64be1126a.svg";
export { ForwardRef as ReactComponent };